import { getEntityParametersAsObject, getEntityPropertyValue } from 'utils/entityUtils';

export const NOT_FOUND = 'NOT_FOUND';

export function formatViewDateInterval(msg, startDate, endDate) {
  if (startDate && endDate && startDate !== endDate) {
    return msg({ id: 'view.common.date.interval' }, { startDate, endDate });
  }
  return msg({ id: 'view.common.date.single' }, { date: startDate || endDate });
}

/**
 * Checks if a message contains a variable.
 * @param msg the message
 * @returns {*|boolean} true if the message contains a variable
 */
export function containsVariable(msg) {
  const res = msg.match(/\{[a-zA-Z0-9_]+\}/);
  return res && res.length >= 1;
}

/**
 * Formats an event title.
 * @param msg the message formatter
 * @param viewName the view name
 * @param viewConf the view configuration
 * @param entity the entity
 * @param defaultTitle the default title
 * @returns {*} the event title
 */
export function formatEventTitle(msg, viewName, viewConf, entity, defaultTitle) {
  let title = '';
  try {
    const entityParametersAsObject = getEntityParametersAsObject(entity, 'NONE');
    title = msg(
      {
        id: `view.${viewName}.event.title`
      },
      entityParametersAsObject
    );
  } catch (e) {
    console.error(e);
  }
  if (viewConf.folderEntityStartDateCode || viewConf.folderEntityEndDateCode) {
    title = formatViewDateInterval(
      msg,
      getEntityPropertyValue(
        entity,
        viewConf.folderEntityStartDateCode,
        viewConf.folderEntityDateFormat
      ),
      getEntityPropertyValue(
        entity,
        viewConf.folderEntityEndDateCode,
        viewConf.folderEntityDateFormat
      )
    );
  }
  if (!title) {
    title = defaultTitle || `view.${viewName}.event.title`;
  }
  return title;
}
